import loadable from '@loadable/component';

const Tooltip = loadable(() =>
  import(/* webpackChunkName: "tooltip-component" */ "./main")
)
export default Tooltip;
